import { creditNoteSlice } from './slice';

export const {
  setCreditNoteState,
  setAvailableCredit,
  setAllProjects,
  setCreditNoteBasicDetails,
  setLineItems,
  createLineItem,
  insertLineItems,
  deleteLineItem,
  updateLineItem,
  updateLineItemOrder,
  updateAllLineItemsTaxAndFinalAmount,
  resetAllData,
  addProjectAndCurrency,
  removeProject,
  setSourceMappingOrder,
  setFields,
  resetProjectItems,
  resetImportedItems,
} = creditNoteSlice.actions;

export const creditNoteReducer = creditNoteSlice.reducer;
